(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDetailController', CommunicationTopicCategoryDetailController);

    CommunicationTopicCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDetailController($scope, $rootScope, $stateParams, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.load = function (id) {
            CommunicationTopicCategory.get({id: id}, function(result) {
                vm.communicationTopicCategory = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationTopicCategoryUpdate', function(event, result) {
            vm.communicationTopicCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
